import { RootState } from "../../store";
import { UsersMentionsState } from "./contracts/state";
import { LoadingStatus } from "../../../types/common";

export const selectUsersMentionsState = (state: RootState): UsersMentionsState => state.mentionsList;
export const selectUsersMentionsList = (state: RootState): UsersMentionsState["users"] => selectUsersMentionsState(state).users;
export const selectUsersPagesCount = (state: RootState): UsersMentionsState["pagesCount"] => selectUsersMentionsState(state).pagesCount;
export const selectUsersSearchIsLoading = (state: RootState): boolean => selectUsersMentionsState(state).loadingState === LoadingStatus.LOADING;

export const selectMentionUserDetail = (state: RootState): UsersMentionsState["userDetail"] => selectUsersMentionsState(state).userDetail;